import React, { useEffect, useState } from "react";
import api from "@utils/api";
import { useNavigate } from "react-router-dom";
import CommunityImages from "@layout/community";

const Community = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [authorData, setAuthorData] = useState({});
  const [titleAuthorName, setTitleAuthorName] = useState("");
  const [InvalidTokenComponent, setInvalidTokenComponent] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  useEffect(() => {
    setIsLoading(true);
    const headers = { Authorization: `Bearer ${token}` };
    api
      .get("/user-profile", { headers })
      .then((res) => {
        setIsLoading(false);
        setAuthorData(res?.data?.data);
        setTitleAuthorName(res?.data?.data?.full_name);
      })
      .catch((error) => {
        if (error.response) {
          setInvalidTokenComponent(true);
          const errorData = error?.response?.data;
          const backend = {};
          if (errorData.messages) {
            backend.messages = errorData?.messages[0]?.message;
          }
          if (errorData.error) {
            backend.error = errorData?.error;
          }
          setBackendErrors(backend);
          setIsLoading(false);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error: ", error?.message);
        }
      });
  }, [token]);
  console.log("MAIN AUTHOR DATA", authorData);
  return (
    <div>
      <CommunityImages authorData={authorData} />
    </div>
  );
};

export default Community;
